import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

const PermitBarcode = ({ value }) => {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (barcodeRef.current && value) {
      JsBarcode(barcodeRef.current, value, {
        format: "CODE128", // perfect for "PRT-2826-884821"
        width: 1.4, // bar thickness (matches your image)
        height: 28, // height of the bars
        displayValue: true, // show the text under the barcode
        font: "monospace",
        fontSize: 11,
        textMargin: 4,
        margin: 0, // no extra padding
        background: "transparent",
        lineColor: "#17223B", // same dark color you used before
        textAlign: "center",
        textPosition: "bottom",
      });
    }
  }, [value]);

  return <svg ref={barcodeRef} className="w-full max-w-70" />;
};

export default PermitBarcode;
